
import {getStore, setStore} from '@/util/store'
import {getToken, setToken} from "@/util/auth";

const user = {
    state: {
        accessMenuId: '',
        roles: [],
        isCloseTip: false,
        menu: [],//递归后的菜单
        token: getToken(),
        // token: 'chenbx1',
        resourceToken: '',
        prevention: 'first',//内幕防控
        equityChanges: 'first',//股份变动
        informationDisclosure: 'first',//信息披露
        caseReview: 'first',
        complianceAudit: 'first',
        legalResourcesType: 1,
        compliancePush: 'one',
        comprehensiveComplianceInquiry: 'five',
        accessToken: '',
        userName: '',
        deptId: '',
        depNname: '',
        uid: '',
        applicant: [],
        role: false,  // 判断用户是否为超管，true是   false否
        haveNumber: 0,//0为第一次加载已办
    },
    actions: {},
    mutations: {
        //  设置角色
        SET_ROLE: (state, role) => {
            state.role = role
        },
        //左侧菜单 树结构
        SET_MENU: (state, menu) => {
            state.menu = menu
        },
        SET_UID: (state, uid) => {
            state.uid = uid
        },
        SET_DEPNAME: (state, name) => {
            state.depNname = name
        },
        SET_USERNAME: (state, menu) => {
            state.userName = menu
        },
        SET_DEPTID: (state, menu) => {
            state.deptId = menu
        },
        SET_MENU1: (state, menu) => {
            if (menu == '/resourceManagementLogin/index') menu = '/litigation/index'
            state.accessMenuId = menu
        },
        SET_TOKEN: (state, token) => {
            setToken(token)
            setStore({name: "token", content: token, type: "session"});
            state.token = token
        },
        SET_ACCESSTOKEN: (state, token) => {
            state.accessToken = token
        },
        SET_PREVENTION: (state, prevention) => {
            state.prevention = prevention
        },
        SET_EQUITYCHANGES: (state, equityChanges) => {

            state.equityChanges = equityChanges
        },
        SET_INFORMATIONDISCLOSURE: (state, informationDisclosure) => {
            state.informationDisclosure = informationDisclosure
        },
        SET_APPLICANT: (state, applicant) => {
            state.applicant = applicant
        }

    },
}
export default user
